// extracted by mini-css-extract-plugin
module.exports = {"logout_btn":"Logout_logout_btn__3i08L","btn":"Logout_btn__1dxou"};